// src/components/Process.js
import React from 'react';
import './Process.css';

function Process() {
  const steps = [
    {
      icon: "fas fa-seedling",
      title: "Plantación",
      description: "Selección de variedades premium y preparación de terreno orgánico.",
      color: "step-olive",
      shortDesc: "Variedades selectas en suelos ideales"
    },
    {
      icon: "fas fa-tint",
      title: "Cuidado",
      description: "Riego optimizado y fertilización 100% natural para cultivos saludables.",
      color: "step-pecan",
      shortDesc: "Cuidado sostenible y natural"
    },
    {
      icon: "fas fa-sun",
      title: "Cosecha",
      description: "Recolección manual en el momento óptimo de maduración.",
      color: "step-almond",
      shortDesc: "Cosecha en punto perfecto"
    },
    {
      icon: "fas fa-truck",
      title: "Entrega",
      description: "Procesamiento inmediato y envasado al vacío para máxima frescura.",
      color: "step-delivery",
      shortDesc: "Fresco hasta tu puerta"
    }
  ];

  return (
    <section id="proceso" className="compact-process-section">
      <div className="container">
        <div className="compact-section-header">
          <h2 className="section-title">Proceso de Cultivo</h2>
          <p className="compact-section-subtitle">
            Cuatro etapas cuidadosamente planificadas para ofrecerte productos de la más alta calidad.
          </p>
        </div>
        
        <div className="compact-process-grid">
          {steps.map((step, index) => (
            <div className="compact-process-card" key={index}>
              {/* Número con efecto */}
              <div className="step-index">
                <span className="step-index-number">{index + 1}</span>
                <div className="step-index-line"></div>
              </div>
              
              {/* Icono circular */}
              <div className={`compact-step-icon ${step.color}`}>
                <i className={step.icon}></i>
              </div>
              
              {/* Contenido */}
              <div className="compact-step-content">
                <h3 className="compact-step-title">{step.title}</h3>
                <p className="compact-step-short">{step.shortDesc}</p>
                <p className="compact-step-description">{step.description}</p>
              </div>
              
              {/* Flecha indicadora (excepto última) */}
              {index < steps.length - 1 && (
                <div className="compact-step-arrow">
                  <i className="fas fa-arrow-right"></i>
                </div>
              )}
            </div>
          ))}
        </div>
        
        {/* Pie de sección */}
        <div className="process-footer">
          <div className="process-badge">
            <i className="fas fa-award"></i>
            <span>Calidad certificada en cada etapa</span>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Process;